// extracted by mini-css-extract-plugin
export var change = "_3k-1";
export var changeList = "_3k-0";
export var changePath = "_3k-2";
export var diffArrow = "_3k-5";
export var diffRow = "_3k-3";
export var diffValue = "_3k-4";
export var error = "_3k-8";
export var notice = "_3k-9";
export var result = "_3k-6";
export var success = "_3k-7";